import PromosService from '@/service/PromosService';
import UploadImageService from '@/service/UploadImageService';
import { defineStore } from 'pinia';

export const usePromosStore = defineStore('promosStore', {
  state: () => {
    return {
      isSidePromoUpdate: false,
      isAccordionPromoUpdate: false
    };
  },
  getters: {
    getUrlUploadImg: () => {
      const Service = new UploadImageService();
      return Service.urlImage;
    }
  },
  actions: {
    async submitPromos(payload, tab) {
      const Service = new PromosService();
      const res = await Service.submitPromos(payload, tab);
      return res?.data;
    },
    async submitSectionTitlePromos(payload) {
      const Service = new PromosService();
      const res = await Service.submitSectionTitlePromos(payload);
      return res?.data;
    },
    async deletePromos(id, tab) {
      const Service = new PromosService();
      const res = await Service.deletePromos(id, tab);
      return res?.data;
    },
    async getTopbarInfo() {
      const Service = new PromosService();
      const res = await Service.getTopbarInfo();
      return res?.data;
    },
    async getTopBannerHomePageInfo() {
      const Service = new PromosService();
      const res = await Service.getTopBannerHomePageInfo();
      return res?.data;
    },
    async submitTopBanner(payload) {
      const Service = new PromosService();
      const res = await Service.submitTopBanner(payload);
      return res?.data;
    },
    async getBottomBannerHomePageInfo() {
      const Service = new PromosService();
      const res = await Service.getBottomBannerHomePageInfo();
      return res?.data;
    },
    async submitBottomBanner(payload) {
      const Service = new PromosService();
      const res = await Service.submitBottomBanner(payload);
      return res?.data;
    },
    async getSidePromoInfo() {
      const Service = new PromosService();
      const res = await Service.getSidePromoInfo();
      return res?.data;
    },
    async getSectionTitlePromo() {
      const Service = new PromosService();
      const res = await Service.getSectionTitlePromo();
      return res?.data;
    },
    async getPromoBox() {
      const Service = new PromosService();
      const res = await Service.getPromoBox();
      return res?.data;
    },
    async getFormPromo() {
      const Service = new PromosService();
      const res = await Service.getFormPromo();
      return res?.data;
    },
    async getSurfacePromos() {
      const Service = new PromosService();
      const res = await Service.getSurfacePromos();
      return res?.data;
    },
    async getAccordionPromos() {
      const Service = new PromosService();
      const res = await Service.getAccordionPromos();
      return res?.data;
    }
  }
});
